import React from 'react';
import { Snackbar, Button, IconButton, Box, Typography } from '@mui/material';
import { Close, GetApp } from '@mui/icons-material';
import { useInstallPrompt } from '../../hooks/useInstallPrompt';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Floating "Add to Home Screen" banner. Appears once per device on browsers
 * that support PWA install (Chrome/Edge on Android/desktop).
 * Dismissed state is persisted in localStorage.
 */
const InstallBanner = () => {
  const { canInstall, install, dismiss } = useInstallPrompt();
  const { t } = useLanguage();

  if (!canInstall) return null;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 80, sm: 24 } }}
    >
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 1.5,
        bgcolor: '#1f2937', color: '#fff',
        borderRadius: 2, px: 2, py: 1.25,
        boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
        maxWidth: 380,
      }}>
        <GetApp sx={{ fontSize: 20, opacity: 0.8, flexShrink: 0 }} />
        <Typography variant="body2" sx={{ flex: 1, fontSize: '0.85rem' }}>
          {t('installApp') || 'Add TerraMind to your home screen'}
        </Typography>
        <Button
          size="small"
          onClick={install}
          sx={{ color: '#10b981', fontWeight: 700, fontSize: '0.8rem', px: 1 }}
        >
          {t('install') || 'Install'}
        </Button>
        <IconButton size="small" onClick={dismiss} aria-label={t('ariaDismissInstall')}
          sx={{ color: 'rgba(255,255,255,0.5)', p: 0.25 }}>
          <Close sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    </Snackbar>
  );
};

export default InstallBanner;
